import React from 'react';
import { TextField } from '@mui/material';
import ButtonWithLoader from '../../../../components/other/Buttons/ButtonWithLoader';
import homeStyles from '../../../../constants/homeStyles';
import { useFormatMessage } from '../../../../hooks';
import { useStylesProductPage } from '../hooks/useStylesProductPage';

interface IProps {
  formik: any;
  editLoading: boolean;
}

export const ProductPromelecForm: React.FC<IProps> = ({ formik, editLoading }) => {
  const fm = useFormatMessage();
  const homeClasses = homeStyles();
  const { classes } = useStylesProductPage();

  const { handleSubmit, values, handleChange } =
    formik;

  return (
    <>
      <div className={homeClasses.classes.form} style={{ paddingTop: 0 }}>
        <TextField
          type='number'
          label='Шт. в упаковке'
          margin='normal'
          name='promelec_params.pack_quant'
          value={values.promelec_params?.pack_quant || 0}
          variant='outlined'
          onChange={handleChange}
        />
        <TextField
          type='number'
          label='Единица товара'
          margin='normal'
          name='promelec_params.price_unit'
          value={values.promelec_params?.price_unit || 0}
          variant='outlined'
          onChange={handleChange}
        />
        <TextField
          type='text'
          label='Единица измерения'
          margin='normal'
          name='promelec_params.munit'
          value={values.promelec_params?.munit || ''}
          variant='outlined'
          onChange={handleChange}
        />
        <TextField
          type='text'
          label='Производитель'
          margin='normal'
          name='promelec_params.producer_name'
          value={values.promelec_params?.producer_name || ''}
          variant='outlined'
          onChange={handleChange}
        />
        <TextField
          type='text'
          label='Примечание'
          margin='normal'
          name='promelec_params.remark'
          value={values.promelec_params?.remark || ''}
          variant='outlined'
          onChange={handleChange}
        />
        <TextField
          type='text'
          label='Описание на английском'
          margin='normal'
          name='promelec_params.description_eng'
          value={values.promelec_params?.description_eng || ''}
          variant='outlined'
          onChange={handleChange}
        />
        <TextField
          type='text'
          label='Рабочие температуры'
          margin='normal'
          name='promelec_params.temperature'
          value={values.promelec_params?.temperature || ''}
          variant='outlined'
          onChange={handleChange}
        />
        <TextField
          type='text'
          label='Тип корпуса'
          margin='normal'
          name='promelec_params.package'
          value={values.promelec_params?.package || ''}
          variant='outlined'
          onChange={handleChange}
        />
        <TextField
          type='text'
          label='Тип упаковки'
          margin='normal'
          name='promelec_params.packaging'
          value={values.promelec_params?.packaging || ''}
          variant='outlined'
          onChange={handleChange}
        />
        <TextField
          type='number'
          label='Вес брутто единицы товара, г'
          margin='normal'
          name='promelec_params.weight'
          value={values.promelec_params?.weight || 0}
          variant='outlined'
          onChange={handleChange}
        />

        <div className={classes.actions}>
          <ButtonWithLoader disabled={editLoading} loading={editLoading} onPress={handleSubmit}>
            {fm('COMMON.BUTTON.SAVE')}
          </ButtonWithLoader>
        </div>
      </div>
    </>
  );
};
